// extracted by mini-css-extract-plugin
export default {"warp":"preset_apps_warp__bmJHz","home_title":"preset_apps_home_title__gkIlV","foot":"preset_apps_foot__zC0D-"};